import { useEffect, useState } from 'react';

export const Stepper = ({ steps, current }) => (
  <div className="flex items-center justify-between w-full" data-testid="stepper">
    {steps.map((s, i) => {
      const done = i < current;
      const active = i === current;
      return (
        <div key={s} className="flex items-center flex-1 last:flex-none">
          <div className={`h-8 w-8 rounded-full flex items-center justify-center text-xs font-semibold ${done ? 'bg-[#1F9D63] text-white' : active ? 'bg-[#1677F2] text-white' : 'bg-[#E2E8F0] text-slate-500'}`}>
            {done ? '✓' : i + 1}
          </div>
          {i < steps.length - 1 && (
            <div className={`flex-1 h-0.5 mx-2 ${done ? 'bg-[#1F9D63]' : 'bg-[#E2E8F0]'}`} />
          )}
        </div>
      );
    })}
  </div>
);

export const EmptyState = ({ icon: Icon, title, description, action, testid = 'empty-state' }) => (
  <div data-testid={testid} className="flex flex-col items-center text-center py-12 px-6">
    {Icon && (
      <div className="h-16 w-16 rounded-full bg-[#EAF3FF] flex items-center justify-center text-[#1677F2] mb-4">
        <Icon size={28} />
      </div>
    )}
    <h3 className="text-lg font-semibold text-[#0B1220]">{title}</h3>
    {description && <p className="text-sm text-slate-600 mt-1 max-w-sm">{description}</p>}
    {action && <div className="mt-4">{action}</div>}
  </div>
);

export const StarRating = ({ value = 0, onChange, readonly = false, size = 20 }) => {
  const [hover, setHover] = useState(0);
  const display = hover || value;
  return (
    <div className="inline-flex gap-0.5" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => !readonly && onChange && onChange(n)}
          onMouseEnter={() => !readonly && setHover(n)}
          onMouseLeave={() => setHover(0)}
          data-testid={`star-rating-${n}`}
          className={`${readonly ? 'cursor-default' : 'cursor-pointer'} p-0.5`}
        >
          <svg width={size} height={size} viewBox="0 0 24 24" fill={n <= display ? '#F7D618' : '#E2E8F0'}>
            <polygon points="12,2 15,9 22,9.3 17,14 18.5,21 12,17.5 5.5,21 7,14 2,9.3 9,9" />
          </svg>
        </button>
      ))}
    </div>
  );
};

export const useMediaQuery = (query) => {
  const [match, setMatch] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const handler = (e) => setMatch(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [query]);
  return match;
};
